var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRainDrop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.61476 9.51027C4.24745 10.143 5.10524 10.4989 6 10.5C6.89476 10.4989 7.75255 10.143 8.38524 9.51027C9.01793 8.87758 9.37387 8.0198 9.375 7.12504C9.35344 6.45973 9.15629 5.81196 8.80354 5.24745L6.3177 1.2888C6.28164 1.23815 6.23399 1.19685 6.17872 1.16836C6.12346 1.13987 6.06218 1.125 6 1.125C5.93782 1.125 5.87654 1.13987 5.82128 1.16836C5.76601 1.19685 5.71836 1.23815 5.6823 1.2888L3.18529 5.26676C2.83843 5.82617 2.64517 6.46713 2.625 7.12504C2.62613 8.0198 2.98207 8.87758 3.61476 9.51027ZM3.83186 5.64611L6 2.19315L8.157 5.6268C8.44219 6.0763 8.60363 6.59313 8.625 7.12504C8.625 7.82123 8.34844 8.48891 7.85616 8.98119C7.36387 9.47348 6.69619 9.75004 6 9.75004C5.30381 9.75004 4.63613 9.47348 4.14384 8.98119C3.65156 8.48891 3.375 7.82123 3.375 7.12504C3.3949 6.60052 3.55246 6.09047 3.83186 5.64611ZM6 8.25V9C6.48945 8.97577 6.95242 8.77045 7.29894 8.42394C7.64545 8.07742 7.85077 7.61445 7.875 7.125H7.125C7.09991 7.41495 6.97332 7.68674 6.76753 7.89253C6.56174 8.09832 6.28995 8.22491 6 8.25Z",
    fill: "#FFFFFF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainDrop);
export default __webpack_public_path__ + "static/media/rain-drop.19e372c0.svg";
export { ForwardRef as ReactComponent };